import Plyr from 'plyr';

const video = {
  btns: document.querySelectorAll('.jsLoadVideo') as NodeListOf<HTMLElement>,
  ele: document.getElementById('jsVideoPlayer') as HTMLElement,
  player: null as Plyr | null,

  init() {
    this.setVideo();
  },

  setVideo() {
    document.addEventListener('DOMContentLoaded', () => {
      this.btns.forEach((btn) => {
        btn.addEventListener('click', () => {
          const videoId: string | null = btn.getAttribute('data-video-id');

          if (videoId) {
            this.ele.innerHTML = `
                            <iframe src="https://www.youtube.com/embed/${videoId}?autoplay=1&mute=0" 
                                    allow="accelerometer;clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                    allowfullscreen
                                    style="width: 100%; height: 100%; border: none;"></iframe>`;

            if (!this.player) {
              const iframe = this.ele.querySelector('iframe');
              if (iframe) {
                this.player = new Plyr(iframe, {
                  controls: [],
                  autoplay: false,
                });
              }
            }
          }
        });
      });
    });
  },
};

export default video;
